import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import "@/App.css";
import Dashboard from "@/features/dashboard/Dashboard";
import LandingPage from "@/features/landing/LandingPage";
import AuthPage from "@/features/auth/AuthPage";
import { AuthProvider, useAuth } from "@/features/auth/AuthProvider";

// Kicked-out visitors go to /auth and return to where they were headed.
// Deliberately defined OUTSIDE the rendering component: a component
// created inside a render gets a new identity every render, which makes
// React unmount and remount its whole subtree.
function ProtectedRoute({ children }) {
  const { token } = useAuth();
  const location = useLocation();
  if (!token) {
    return <Navigate to="/auth" replace state={{ from: location.pathname }} />;
  }
  return children;
}

function AppRoutes() {
  const { token } = useAuth();
  return (
    <Routes>
      <Route
        path="/auth"
        element={token ? <Navigate to="/dashboard" replace /> : <AuthPage />}
      />
      <Route path="/login" element={<Navigate to="/auth" replace />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/"
        element={token ? <Navigate to="/dashboard" replace /> : <LandingPage />}
      />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}
